module.exports = __webpack_public_path__ + "@/assets/img/discover.12ef5de5.svg";